export default __webpack_public_path__ + "static/media/SIGHTMACHINE.969421ed.png";